/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NonceChallengeOptions
 */
export interface NonceChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof NonceChallengeOptions
     */
    challenge?: string;
}

/**
 * Check if a given object implements the NonceChallengeOptions interface.
 */
export function instanceOfNonceChallengeOptions(value: object): value is NonceChallengeOptions {
    return true;
}

export function NonceChallengeOptionsFromJSON(json: any): NonceChallengeOptions {
    return NonceChallengeOptionsFromJSONTyped(json, false);
}

export function NonceChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
    };
}

export function NonceChallengeOptionsToJSON(json: any): NonceChallengeOptions {
    return NonceChallengeOptionsToJSONTyped(json, false);
}

export function NonceChallengeOptionsToJSONTyped(value?: NonceChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': value['challenge'],
    };
}

